import SitesImportModal from './SitesImportModal';
import './SitesImportModal.scss';

export default SitesImportModal;
